// extracted by mini-css-extract-plugin
module.exports = {"noEval-page":"containers-Dashboard-NoEvalsPage-NoEvalsPage__noEval-page--2XK0y"};